import React, { useState } from "react";
import "./PatientDataInformationTabBar.css";

const PatientDataInformationTabBar = ({ onSelect }) => {
  const [activeTab, setActiveTab] = useState("pharmacy");

  const handleSelect = (tab) => {
    setActiveTab(tab);
    onSelect(tab);
  };

  return (
    <div className="tab-bar">
      <button
        className={`tab-item ${activeTab === "pharmacy" ? "active" : ""}`}
        onClick={() => handleSelect("pharmacy")}
      >
        Apotek
      </button>
      <button
        className={`tab-item ${activeTab === "clinic" ? "active" : ""}`}
        onClick={() => handleSelect("clinic")}
      >
        Klinik Gigi
      </button>
    </div>
  );
};

export default PatientDataInformationTabBar;
